import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const inAppChannel = defineChannel({
  id: 'in_app',
  icon: 'in-app',
} as const satisfies ChannelDefinition);
